// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { FormInputWrapper } from "@insite/mobius/FormField";
import { IconWrapper } from "@insite/mobius/Icon";
import { customerPartNumberStyles } from "@pace/Overrides/Widgets/ProductDetails/ProductDetailsCustomerPartNumber";
import { fontConfig } from "@pace/XDL/PreStyle/typography";
import { color, partNumberSharedStyles } from "@pace/XDL/Utilities";
import { css } from "styled-components";

customerPartNumberStyles.valueContainer = {
    css: css`
        font-size: 12px;
        line-height: 13px;
        color: ${color("common.ui5")};
        display: flex;
        align-items: center;
        gap: 4px;
    `,
};

customerPartNumberStyles.labelText = {
    ...partNumberSharedStyles.erpNumberLabelText,
    color: "text",
    css: css`
        &::after {
            content: ":";
        }
    `,
};

customerPartNumberStyles.editButton = {
    css: css`
        ${IconWrapper} {
            width: 14px;
            height: 14px;
            color: ${color("secondary")};
        }
    `,
};

customerPartNumberStyles.editForm = {
    css: css`
        display: flex;
        gap: 4px;
        height: 33px;
        ${FormInputWrapper} {
            width: 72px;
            input {
                height: 33px;
            }
        }
    `,
};

customerPartNumberStyles.cpnField = {
    css: css`
        display: flex;
        gap: 4px;
        align-items: center;
    `,
};

customerPartNumberStyles.formButton = {
    css: css`
        ${({ value }: any) => (value ? `padding: 7px 6px` : `padding: 7px 24px`)}
    `,
};

customerPartNumberStyles.infoTooltip = {
    label: {
        weight: fontConfig.weight.semiBold,
        size: 16,
        color: "text.main",
        lineHeight: "13px",
        css: css`
            &::after {
                content: ":";
            }
        `,
    },
    value: {
        weight: fontConfig.weight.regular,
        size: 14,
        color: "text.main",
        lineHeight: "13px",
    },
};